import { createFileRoute } from "@tanstack/react-router";
import type { SearchSchemaInput } from "@tanstack/react-router";
import { SectionPage } from "@/components/SectionPage";
import { RelatedHubs } from "@/components/RelatedHubs";
import { getSeoSectionItems } from "@/lib/seo.functions";
import { buildHreflangLinks, buildLocaleMeta } from "@/lib/i18n-paths";

export const Route = createFileRoute("/fi/do")({
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput): { q?: string; page?: number; lane?: string } => ({
    q: typeof search.q === "string" ? search.q : undefined,
    page: Number(search.page) > 0 ? Number(search.page) : 1,
    lane: typeof search.lane === "string" ? search.lane : undefined,
  }),
  loader: async () => {
    try {
      const { items } = await getSeoSectionItems({ data: { section: "do", limit: 30 } });
      return { items };
    } catch {
      return { items: [] };
    }
  },
  head: ({ loaderData }) => {
    const items = loaderData?.items ?? [];
    const url = "https://whatfinland.com/fi/do";
    const itemList = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "Mitä tehdä Suomessa — kuratoituja kokemuksia, saunoja ja saaristoretkiä",
      url,
      inLanguage: "fi",
      numberOfItems: items.length,
      itemListElement: items.map((it, i) => ({
        "@type": "ListItem",
        position: i + 1,
        url: `https://whatfinland.com/fi/place/${it.slug}`,
        name: it.name,
      })),
    };
    return {
      meta: [
        { title: "Mitä tehdä Helsingissä — Saunat, Saaristo & Design" },
        { name: "description", content: "Käsin valitut kokemukset, saunat, saaristoretket, designkävelyt ja aktiviteetit Helsingissä." },
        { property: "og:title", content: "Mitä tehdä — Helsinki" },
        { property: "og:description", content: "Asioita, jotka kannattaa nähdä ja kokea Helsingissä." },
        { property: "og:url", content: url },
        ...buildLocaleMeta("fi"),
      ],
      links: [
        { rel: "canonical", href: url },
        ...buildHreflangLinks("/fi/do"),
      ],
      scripts: [{ type: "application/ld+json", children: JSON.stringify(itemList) }],
    };
  },
  component: () => (
    <>
      <SectionPage section="do" />
      <RelatedHubs current="do" />
    </>
  ),
});
